module.exports = __webpack_public_path__ + "img/feature_buy_en.dbb87845.png";